import { cva } from 'class-variance-authority';

export const Content = cva([
  'z-50',
  'overflow-hidden',
  'rounded-md',
  'border',
  'border-neutral-200',
  'bg-white',
  'px-3',
  'py-1.5',
  'text-sm',
  'text-neutral-950',
  'shadow-md',
  'animate-in',
  'fade-in-0',
  'zoom-in-95',
  'data-[state=closed]:animate-out',
  'data-[state=closed]:fade-out-0',
  'data-[state=closed]:zoom-out-95',
  'data-[side=bottom]:slide-in-from-top-2',
  'data-[side=left]:slide-in-from-right-2',
  'data-[side=right]:slide-in-from-left-2',
  'data-[side=top]:slide-in-from-bottom-2',
]);
